import { z } from 'zod';
import { isStorableCalendarDate } from '../../dates/index.js';
import { capitalize } from '../../utils/capitalize.js';
import { CUSTOMER_LICENSE_CONSTRAINTS as LIMITS } from './constraints.js';
import { LICENSE_DATE_ORDER_MESSAGE } from './license-date-order-message.js';
// Blank, or the picker's `YYYY-MM-DD`.
const formDateString = z
    .string()
    .refine((value) => value === '' || isStorableCalendarDate(value), { message: 'Invalid date.' });
export const customerLicenseFormSchema = z
    .object({
    licenseNumber: z
        .string()
        .trim()
        .min(1, `${capitalize(LIMITS.licenseNumber.label.toLowerCase())} is required.`)
        .max(LIMITS.licenseNumber.maxLength),
    licenseType: z.string().trim().max(LIMITS.licenseType.maxLength),
    stateId: z.string().min(1, `${capitalize(LIMITS.stateId.label.toLowerCase())} is required.`),
    issuedAt: formDateString,
    expiresAt: formDateString,
})
    .refine((values) => !values.issuedAt || !values.expiresAt || values.expiresAt >= values.issuedAt, {
    path: ['expiresAt'],
    message: LICENSE_DATE_ORDER_MESSAGE,
});
//# sourceMappingURL=form.js.map